export default [
  'novita',
  'verniciatura',
  'inFoglia',
  'speciale',
  'ottoni',
  'marmi',
  'cavo',
]
